import script from "./LogTral.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogTral.vue?vue&type=script&lang=ts&setup=true"

import "./LogTral.vue?vue&type=style&index=0&id=caff9854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caff9854"]])

export default __exports__